import { Store, select } from '@ngrx/store';
import * as translation from './state';
import { Translation } from './models/translation.model';
import { Injectable } from '@angular/core';
import { BabelService } from 'src/app/shared/data-service/babel.service';
 
@Injectable({
    providedIn: 'root'
})
export class TranslationService {
 
    private static translations: any;
 
    constructor(private store: Store<translation.State>) {
        let language = sessionStorage.getItem('LanguageCode');
        if(language === undefined || language === null ){
            language = "en";
        }
        TranslationService.translations = JSON.parse(sessionStorage.getItem(language))
    }
 
    static translate(value: string): string {
        return BabelService.translate(value).replace(/\$lineBreak\$/g, '\r\n').replace(/\\r\\n/g, '\r\n');
    }
}